module.exports = __webpack_public_path__ + "img/Outline.cfd20ef2.svg";